const statuses = {
	active: 'active',
	hidden: 'hidden'
};

const locale = {
	ru: {
		active: 'активна',
		hidden: 'скрыта'
	},
	en: statuses,
	uk: statuses,
	de: {
		active: 'aktiv',
		hidden: 'versteckt'
	},
	vi: statuses,
	th: {
		active: 'ใช้งานได้',
		hidden: 'ถูกซ่อน'
	}
};

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/payout-system-statuses.js